import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { USER_ROLES_API } from "../apiRoutes";

interface mutateProps {
  userRoleId: string;
}
const mutateDeleteUserRole = async ({
  userRoleId,
}: mutateProps) => {
  return await axiosAuth.delete(
    `${USER_ROLES_API}/${userRoleId}`);
};

const useDeleteUserRoleMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateDeleteUserRole,
    ...queryParams,
  });

export default useDeleteUserRoleMutation;
